import { stringify } from "querystring";

export default {
    data () {
        return {
            inspections: [],
            inspectionsMeta: {
                total: 0,
                page: 0
            }
        };
    },
    methods: {
        inspectionPath (inspection) {
            return 'inspections/' + inspection.id;
        },

        queryInspections (search, search_include, region_filter, status_filter, count, skip, callback = () => {}) {
            // var search = this.search ? '&q=id=' + this.search + '|^landowner.first_name=' : '';
            var self = this;
            var paramString = `?include=region,status,contact,parcels,inspector&count=${count}&page=${ Math.floor(skip / count) }`;

            // DUMB
            if (search) {
                if (paramString) {
                    paramString += '&q=';
                } else {
                    paramString += '?q=';
                }
                paramString += encodeURIComponent(search);
            }
            if (search_include) {
                if (paramString) {
                    paramString += '&qi=';
                } else {
                    paramString += '?qi=';
                }
                paramString += encodeURIComponent(search_include);
            }

            if (region_filter) {
                if (paramString) {
                    paramString += '&region_abbr=';
                } else {
                    paramString += '?region_abbr=';
                }
                paramString += encodeURIComponent(region_filter);
            }

            if (status_filter) {
                if (paramString) {
                    paramString += '&status.typename=';
                } else {
                    paramString += '?status.typename=';
                }
                paramString += encodeURIComponent(status_filter);
            }

            self.axios.get('inspections' + paramString).then((response) => {
                self.inspections = response.data.data;
                self.inspectionsMeta = response.data.meta;

                callback(self.inspections, self.inspectionsMeta);
            });
        },

        createInspection () {
            this.working = true;

            let promise = this.axios.post('inspections').then((response) => {
                this.$toasted.success('Inspection successfully created!');
                this.working = false;
                return response;
            }).catch((err) => {
                console.log(err);
                this.$toasted.error('Error creating inspection, please contact admin', {duration: 6000});
                this.working = false;
            });

            return promise;
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/inspections-api-mixin.js